'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _store = require('linksoft/core/store');

var _store2 = _interopRequireDefault(_store);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions = require('linksoft/core/actions');

var _actions2 = _interopRequireDefault(_actions);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

var _linksoftAlbatros = require('linksoft-albatros');

var _createBrowserHistory = require('history/createBrowserHistory');

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _menuResponsive = require('../initializers/menuResponsive');

var _menuResponsive2 = _interopRequireDefault(_menuResponsive);

var _ajax = require('linksoft/utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _urls = require('../urls');

var _urls2 = _interopRequireDefault(_urls);

var _gtm = require('./gtm');

var _gtm2 = _interopRequireDefault(_gtm);

var _cookie = require('linksoft/utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('cart:actions');
var Resx = (0, _localize2.default)('Messages', 'App', 'Common');
var cartService = _abp2.default.services.api.cartB2c;
var loyaltyProgramService = _abp2.default.services.api.loyaltyProgram;

var history = (0, _createBrowserHistory2.default)();
var stepUrls = ['/Cart/Index/', '/Cart/ChooseFreeProducts/', '/Cart/ChoosePaymentAndDelivery/', '/Cart/Summary/'];

history.listen(function (location, action) {
    if (action === 'POP') {
        var step = location.state && location.state.step || 1;
        _store2.default.get().dispatch(cartActions.setStep(step, true));
    }
});

var onChangeSubmitHandle = 0;

var cartActions = {
    getCart: function getCart() {
        return function (dispatch, getState) {
            var state = getState();
            return state.cart;
        };
    },
    setStep: function setStep(step, fromHistory) {
        return function (dispatch, getState) {
            var state = getState();
            if (state.cart.step === step) return;

            if (step === 2 && !state.cart.freeProducts.length) {
                if (state.cart.step < 2) {
                    step++;
                } else {
                    step--;
                }
            }

            if (step > 3) {
                // require deliveryTypeId and paymentTypeId
                if (!(typeof state.cart.deliveryTypeId === 'number' && typeof state.cart.paymentTypeId === 'number')) {
                    step = 3;
                }
            }

            if (step > 1) {
                // require items in cart
                if (state.cart.items.length === 0 && state.cart.giftItems.length === 0) {
                    step = 1;
                }
            }

            // remove free products if cart contents were changed and free products are no longer accessible 
            if (step > 1) {
                var cart = state.cart;
                var cartTotalPrice = cart.totalPrice.finalPrice;
                var allCampaigns = cart.freeProducts;
                var canPickMultipleFreeProducts = cart.canPickMultipleFreeProductsPerCampaign;
                var products = JSON.parse((0, _stringify2.default)((0, _linksoftAlbatros.getCartOptions)(getState().cart).selectedFreeProducts || []));
                if (canPickMultipleFreeProducts) {

                    var allProducts = allCampaigns.reduce(function (ar, campaign) {
                        return ar.concat(campaign.freeProducts);
                    }, []);

                    var totalFreeProductsCost = products.reduce(function (prev, cur) {
                        var freeProduct = allProducts.find(function (p) {
                            return p.productId == cur.productId && p.discountCampaignId == cur.discountCampaignId;
                        });

                        return prev + cur.amount * freeProduct.minOrderPrice;
                    }, 0);

                    if (totalFreeProductsCost > cartTotalPrice) {
                        dispatch(cartActions.saveOptions({ selectedFreeProducts: [] }, canPickMultipleFreeProducts));
                    }
                }
            }

            if (state.cart.step !== step) {
                dispatch({ type: _actionTypes2.default.CHANGE_STEP, step: step });
                if (!fromHistory) history.push(stepUrls[step - 1], { step: step });
            }
        };
    },

    setCoupon: function setCoupon(code) {
        var replacePrevious = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        return function (dispatch, getState) {
            dispatch({ type: _actionTypes2.default.SETTING_COUPON });
            cartService.setCoupon(code, replacePrevious).done(function (result) {
                switch (result.reason) {
                    case _linksoftAlbatros.CouponResponse.CodeNotValidForCustomerType:
                    case _linksoftAlbatros.CouponResponse.CodeNotFound:
                        _notify2.default.warn(Resx.App.InvalidCouponCode);
                        dispatch({ type: _actionTypes2.default.COUPON_SET });
                        break;

                    case _linksoftAlbatros.CouponResponse.Success:
                        dispatch(cartActions.loadData()).then(function () {
                            dispatch({ type: _actionTypes2.default.COUPON_SET });
                        });
                        break;

                    case _linksoftAlbatros.CouponResponse.AnotherCodeAlreadySet:
                        _message2.default.confirm(Resx.App.ShouldReplaceCouponConfirmMessage, Resx.Messages.ConfirmTitle).then(function () {
                            return dispatch(cartActions.setCoupon(code, true));
                        }).catch(function () {});
                        dispatch({ type: _actionTypes2.default.COUPON_SET });
                        break;
                }
            }).fail(function () {
                dispatch({ type: _actionTypes2.default.COUPON_SET });
                _notify2.default.error(Resx.Messages.CouponIsNotValid);
            });
        };
    },

    getLoyaltyProgramAvailable: function getLoyaltyProgramAvailable() {
        return function (dispatch, getState) {
            loyaltyProgramService.isActive().done(function (result) {
                dispatch({ type: _actionTypes2.default.LOYALTY_PROGRAM_CHECK, loyaltyProgramAvailable: result });
            }).fail(function () {
                // TODO notify.error(Resx.Messages.LoyaltyProgramIsNotAvailable);
            });
        };
    },

    removeCoupon: function removeCoupon(isVoucher) {
        return function (dispatch, getState) {
            if (!isVoucher) isVoucher = false;

            cartService.removeCoupon(isVoucher, getState().cart.isCompact).done(function (result) {
                dispatch(cartActions.update(result));
            }).fail(function (response) {
                console.error(response);
            });
        };
    },

    getSummaryForProducts: function getSummaryForProducts() {
        return function (dispatch, getState) {
            var state = getState();

            var fnMapItem = function fnMapItem(v) {
                return {
                    productId: v.productId,
                    amount: v.amount
                };
            };

            var fnGetItemByPriority = function fnGetItemByPriority(primaryArray, secondaryArray, productId) {
                var item = primaryArray.find(function (p) {
                    return p.productId === productId;
                });
                if (!item) {
                    item = secondaryArray.find(function (p) {
                        return p.productId === productId;
                    });
                }

                return item;
            };

            var changedItems = (0, _values2.default)(state.cart.changes).map(fnMapItem);

            var existingItems = (0, _values2.default)(state.cart.itemAmounts).map(fnMapItem);

            var items = [];
            var amount = 0;

            for (var i = 0; i < state.cart.processedProductIds.length; i++) {
                var productId = state.cart.processedProductIds[i];
                var item = fnGetItemByPriority(changedItems, existingItems, productId);

                if (item) {
                    items.push(item);
                    if (item.amount) amount += item.amount;
                }
            }

            cartService.getPriceForProducts(items).done(function (result) {
                dispatch({ type: _actionTypes2.default.MASS_ORDER_SUMMARY, result: { price: result, amount: amount } });
            });
        };
    },

    setProcessedProducts: function setProcessedProducts(processedProductIds) {
        return { type: _actionTypes2.default.PROCESSED_PRODUCTS, processedProductIds: processedProductIds };
    },

    massChangeAmount: function massChangeAmount(item) {
        return (0, _extends3.default)({ type: _actionTypes2.default.CHANGE_AMOUNT }, item);
    },

    changeAmount: function changeAmount(item) {
        item.amount = item.amount + ''; // ensure amount is always string
        return function (dispatch) {

            _promise2.default.resolve(item.amount === '0').then(function (remove) {
                return remove ? _message2.default.confirm(Resx.Messages.ConfirmDelete, Resx.Messages.ConfirmTitle) : true;
            }).then(function () {
                return dispatch((0, _extends3.default)({ type: _actionTypes2.default.CHANGE_AMOUNT }, item));
            }).then(function () {
                if (onChangeSubmitHandle) {
                    clearTimeout(onChangeSubmitHandle);
                }
                onChangeSubmitHandle = setTimeout(function () {
                    dispatch(cartActions.submitChanges());
                }, 400);
            }).catch(function () {});
        };
    },

    removeItem: function removeItem(item) {
        return function (dispatch) {
            _message2.default.confirm(Resx.Messages.ConfirmDelete, Resx.Messages.ConfirmTitle).then(function () {
                return dispatch(cartActions.submitChanges(item));
            }).catch(function () {});
        };
    },

    // submit
    submitChanges: function submitChanges(item) {
        return function (dispatch, getState) {
            var state = getState();
            if (state.cart.processing) {
                return;
            }
            var items = (0, _isObject2.default)(item) ? [item] : (0, _values2.default)(state.cart.changes).map(function (v) {
                return {
                    giftId: v.giftId,
                    productId: v.productId,
                    amount: v.amount,
                    catalogId: v.catalogId
                };
            });
            dispatch({ type: _actionTypes2.default.SUBMIT_CHANGES, items: items });
            if (!_abp2.default.session) {
                (0, _ajax2.default)({
                    url: '/Account/AuthenticateAnonymous',
                    method: 'post',
                    contentType: 'application/json',
                    dataType: 'json'
                }).done(function (res) {
                    $('input[name="__RequestVerificationToken"]').val(_cookie2.default.getCookie('XSRF-TOKEN'));
                    cartActions.submitChangesInternal(items, state, dispatch);
                }).fail(function (err) {});
            } else {
                cartActions.submitChangesInternal(items, state, dispatch);
            }
        };
    },

    submitChangesInternal: function submitChangesInternal(items, state, dispatch) {
        cartService.update(items, state.cart.isCompact).done(function (result) {
            dispatch({ type: _actionTypes2.default.UPDATE, cart: result });
            if (state.cart.isDetail) {
                (0, _gtm2.default)(result);
            }
            // notify.success(Resx.Messages.SuccessfullyAddedToCart);
        }).fail(function (e) {
            dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
            _notify2.default.error(Resx.Messages.CannotAddToCart);
        });
    },

    // update cart state (usually comes from server)
    update: function update(cart) {
        return function (dispatch) {
            dispatch({ type: _actionTypes2.default.UPDATE, cart: cart });
        };
    },

    // load cart data from server (used for initialization)
    loadData: function loadData() {
        return function (dispatch) {
            dispatch({ type: _actionTypes2.default.LOAD_DATA });

            return cartService.getCart().done(function (result) {
                dispatch({ type: _actionTypes2.default.UPDATE, cart: result });
                // for menu respnosive recalculate
                setTimeout(_menuResponsive2.default, 200);
            }).fail(function () {
                dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
            });
        };
    },

    sendGtmMetrics: function sendGtmMetrics() {
        return function (dispatch, getState) {
            (0, _gtm2.default)(getState().cart);
        };
    },

    empty: function empty() {
        return function (dispatch, getState) {
            var state = getState();
            if (state.cart.processing) {
                return;
            }
            _message2.default.confirm(Resx.Messages.ConfirmClearCart, Resx.Messages.ConfirmTitle, function (isConfirmed) {
                if (isConfirmed) {
                    cartService.clear(state.cart.isCompact).done(function (result) {
                        dispatch({ type: _actionTypes2.default.UPDATE, cart: result });
                    }).fail(function () {
                        dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
                    });
                }
            });
        };
    },

    sendOrder: function sendOrder() {
        return function (dispatch, getState) {
            var state = getState();

            if (state.cart.processing || state.cart.sendingOrder) {
                return;
            }
            dispatch({ type: _actionTypes2.default.ORDERING });

            (0, _ajax2.default)({
                type: 'POST',
                url: (0, _urls2.default)('createOrder')
            }).fail(function (err) {
                // have to scroll to first error
                (0, _linksoftAlbatros.scrollToTop)();

                dispatch({ type: _actionTypes2.default.ORDER_FAILED, error: err });
                if (err && !err.suppressError) {
                    _message2.default.error(err.message || Resx.Messages.OrderFailure);
                    cartService.getCart().done(function (result) {
                        dispatch({ type: _actionTypes2.default.UPDATE, cart: result });
                    });
                }
            });
        };
    },

    // campaignId is id of the collection of free products that the user sees (there may be multiple "real" campaigns merged into that collection)
    // realCampaignId is the id of the campaign for the particular free product in the database
    updateFreeProducts: function updateFreeProducts(campaignId, realCampaignId, addId, addAmount, removeId) {
        return function (dispatch, getState) {
            var cart = getState().cart;
            var cartTotalPrice = cart.totalPrice.finalPrice;
            var allCampaigns = cart.freeProducts;
            var canPickMultipleFreeProducts = cart.canPickMultipleFreeProductsPerCampaign;
            var campaign = allCampaigns.find(function (x) {
                return x.id == campaignId;
            });

            if (!campaign) {
                return false;
            }

            // clone the array to prevent changes from being propagated into the real state before saving
            var products = JSON.parse((0, _stringify2.default)((0, _linksoftAlbatros.getCartOptions)(getState().cart).selectedFreeProducts || []));

            // add or update the amount for the given product
            if (addId) {
                var existingProduct = products.find(function (p) {
                    return p.productId == addId && p.discountCampaignId == realCampaignId;
                });
                if (existingProduct) {
                    existingProduct.amount = addAmount;
                } else {
                    var product = campaign.freeProducts.find(function (p) {
                        return p.productId == addId;
                    });

                    products.push({
                        discountCampaignFreeProductId: product.id,
                        productId: addId,
                        amount: addAmount,
                        discountCampaignId: realCampaignId
                    });
                }

                var orderedAmount = products.reduce(function (prev, cur) {
                    return prev + (cur.productId == addId ? cur.amount : 0);
                }, 0);

                var amountAvailable = campaign.freeProducts.find(function (p) {
                    return p.productId == addId;
                }).amountAvailable;

                if (amountAvailable < orderedAmount) {
                    _notify2.default.error(Resx.Messages.FreeProductsAvailableLimit.replace('{0}', amountAvailable));
                    return false;
                }
            }

            if (canPickMultipleFreeProducts) {
                var allProducts = allCampaigns.reduce(function (ar, campaign) {
                    return ar.concat(campaign.freeProducts);
                }, []);

                var totalFreeProductsCost = products.reduce(function (prev, cur) {
                    var freeProduct = allProducts.find(function (p) {
                        return p.productId == cur.productId && p.discountCampaignId == cur.discountCampaignId;
                    });

                    return prev + cur.amount * freeProduct.minOrderPrice;
                }, 0);

                if (totalFreeProductsCost > cartTotalPrice) {
                    _notify2.default.error(Resx.Messages.FreeProductsCostLimit);
                    return false;
                }
            }

            dispatch(cartActions.saveOptions({ selectedFreeProducts: products.filter(function (p) {
                    return p && !(p.discountCampaignFreeProductId == removeId);
                }) }, canPickMultipleFreeProducts));

            return true;
        };
    },

    saveOptions: function saveOptions(options, notifyOnSuccess) {
        return function (dispatch, getState) {
            dispatch({ type: _actionTypes2.default.OPTIONS_CHANGED, options: options });
            saveCurrentOptions(dispatch, getState, notifyOnSuccess);
        };
    }
};

function saveCurrentOptions(dispatch, getState, notifyOnSuccess) {
    if (optionsChangingHandler) clearTimeout(optionsChangingHandler);
    optionsChangingHandler = setTimeout(function () {
        var _getState = getState(),
            cart = _getState.cart;

        var optionsVersion = cart.optionsVersion,
            savingOptionsVersion = cart.savingOptionsVersion;


        if (savingOptionsVersion) {
            // already saving options
            saveCurrentOptions(dispatch, getState);
            return;
        }

        // write down version we are saving right now, do not let concurrent requests
        dispatch({ type: _actionTypes2.default.OPTIONS_SAVING, version: optionsVersion });
        optionsChangingHandler = 0;

        var allOptions = (0, _linksoftAlbatros.getCartOptions)(cart);
        cartService.saveOptions(allOptions).done(function (result) {
            dispatch({ type: _actionTypes2.default.OPTIONS_SAVED, version: optionsVersion });
            dispatch({ type: _actionTypes2.default.UPDATE, cart: result });
            if (notifyOnSuccess) {
                _notify2.default.success(Resx.Messages.FreeProductsSavedSuccessfully);
            }
        }).fail(function () {
            dispatch({ type: _actionTypes2.default.OPTIONS_SAVING_FAILED });
            _notify2.default.error(Resx.Common.AjaxError);
        });
    }, 500);
}

var optionsChangingHandler = 0;

_actions2.default.add('cart', cartActions);

exports.default = cartActions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/actions.js
// module id = 35
// module chunks = 0